import dayjs from 'dayjs';
import { defaultTo } from 'lodash';

import { formatNumberToCurrencyString } from 'utils/number';

import { MAX_INTEREST_CREDIT_EDITABLE_DAY_IN_MONTH } from './InterestCredit.constants';

export const getInterestCreditValues = ({
  prepaidInterestDays,
  prepaidInterest,
  interestCreditFundingDate,
  hasInterestCredit,
  manualDailyPrepaidInterest,
}) => {
  const hasInterestCreditBool = hasInterestCredit === 'true';
  const computedPerDiem = prepaidInterestDays > 0 ? prepaidInterest / prepaidInterestDays : 0;
  const effectivePerDiem = defaultTo(Number(manualDailyPrepaidInterest), computedPerDiem);

  const previousDayToInterestCreditFundingDate = interestCreditFundingDate
    ? dayjs(interestCreditFundingDate).date() - 1
    : 0;

  const daysInMonthWithoutPreviousDay =
    (interestCreditFundingDate ? dayjs(interestCreditFundingDate).daysInMonth() : 0) -
    previousDayToInterestCreditFundingDate;

  const days = hasInterestCreditBool
    ? previousDayToInterestCreditFundingDate
    : daysInMonthWithoutPreviousDay;

  const total = effectivePerDiem * days * (hasInterestCreditBool ? -1 : 1);

  return {
    perDiem: formatNumberToCurrencyString(interestCreditFundingDate ? computedPerDiem : 0),
    perDiemRaw: interestCreditFundingDate ? computedPerDiem : 0,
    days,
    total: formatNumberToCurrencyString((interestCreditFundingDate ? total : 0) || 0),
    totalRaw: interestCreditFundingDate ? total : 0,
  };
};

export const getIsDisabledInterestCredit = interestCreditFundingDate => {
  const dayNumber = dayjs(interestCreditFundingDate).date();

  return !dayNumber || dayNumber > MAX_INTEREST_CREDIT_EDITABLE_DAY_IN_MONTH;
};
